'use strict';

var React = require('react');
var component = require('../../forms/Input/component.js');
var component$1 = require('../../Icon/component.js');
require('../../Tooltip/component.js');
var pill = require('../../Pill/pill.js');
require('../../Pill/pillButton.styles.js');
var filterPopin_styles = require('./filterPopin.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const FilterRadioPopin = ({ id, node = { current: null }, initialSort, filter, title, radios, isFilterOpen = false, endColumn = false, isFirstCol = false, disableSearch = false, addToCurrentSort = () => null, removeFromCurrentSort = () => null, searchPlaceholder = 'Rechercher', labelRadioNoFilter = 'Sans filtre', pillFirst = false, }) => {
    const [searchValue, setSearchValue] = React.useState(initialSort?.filter === filter && initialSort?.search ? initialSort.search : '');
    const [filterValue, setFilterValue] = React.useState(initialSort?.filter === filter && initialSort?.value ? initialSort.value : '');
    if (!isFilterOpen) {
        return null;
    }
    const onSortBy = (data) => {
        removeFromCurrentSort({ filter });
        if (data.search !== '' || data.value !== '') {
            addToCurrentSort({ ...data, filter });
        }
    };
    const onInputChange = (e) => {
        const val = e.target.value === undefined || e.target.value === null ? '' : e.target.value;
        setSearchValue(val);
        if (val === '' || val.length > 2) {
            onSortBy({ search: val, value: filterValue });
        }
    };
    const onRadioChange = (filterVal) => (e) => {
        setFilterValue(e.target.value);
        onSortBy({ search: searchValue, value: filterVal });
    };
    return (React__default.default.createElement(filterPopin_styles.ContainerStyled, { id: id, ref: node, endColumn: endColumn, isFirstCol: isFirstCol },
        !disableSearch && (React__default.default.createElement(component.Input, { autoFocus: true, id: `${id}-search`, placeholder: searchPlaceholder, value: searchValue, onChange: onInputChange, prefix: React__default.default.createElement(component$1.Icon, { name: "search-filled", size: "m" }) })),
        React__default.default.createElement(filterPopin_styles.FilterDiv, { iFirstElement: disableSearch }, title),
        React__default.default.createElement(filterPopin_styles.FlexDivAll, null,
            React__default.default.createElement(filterPopin_styles.Radio, { id: `${id}-clear`, name: "filter", value: '', checked: filterValue === '', onChange: onRadioChange('') }),
            React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-clear` }, labelRadioNoFilter)),
        radios.map(radio => (React__default.default.createElement(filterPopin_styles.FlexDiv, { key: radio.value, style: { alignItems: 'baseline' } },
            React__default.default.createElement("span", null,
                React__default.default.createElement(filterPopin_styles.Radio, { id: `${id}-radio-${radio.value}`, name: "filter", value: radio.value, checked: filterValue === radio.value, onChange: onRadioChange(radio.value) })),
            React__default.default.createElement("div", null,
                radio.pillColor && pillFirst && React__default.default.createElement(pill.Pill, { color: radio.pillColor, withTooltip: false }),
                React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-radio-${radio.value}` }, radio.label),
                radio.pillColor && !pillFirst && React__default.default.createElement(pill.Pill, { color: radio.pillColor, withTooltip: false })))))));
};

exports.FilterRadioPopin = FilterRadioPopin;
//# sourceMappingURL=filterRadioPopin.js.map
